import 'rxjs/add/operator/map';
import fuse from '../../../_libs/redux-fusion';
import {toggleMenu} from '../../../app/actions/mainMenu';
import {ViewHeaderView} from './ViewHeaderView';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const onToggleMenu = () => dispatch(toggleMenu());

  return props$
    .map(
      (props) => ({
        ...props,
        onToggleMenu,
      }));
};

export const ViewHeaderContainer = fuse(StreamedComponent)(ViewHeaderView);



// WEBPACK FOOTER //
// ./src/js/components/views/ViewHeader/ViewHeaderContainer.js